import "./FullAboutMe.scss";

// Images
import AboutMeBanner from "../../assets/images/AboutMe-Banner.png";
import naveen from "../../assets/images/Naveen-1.jpg";

// Components
import Skills from "./Skills";
import Learning from "./Learnings";
import WhyMe from "./WhyMe";

const FullAboutMe = () => {
    return (
        <section className="fullAboutMe">
            <img className="aboutMeBanner" src={AboutMeBanner} alt="banner" />
            <div className="content-container">
                {/* <div className="over-layer-heading">
                    <h1>Hello, I'm <span className="MyName">Naveen</span>, delighted to make your acquaintance!</h1>
                </div> */}
                <section id="aboutMe">
                    <div>
                        <h1>Who am I?</h1>
                        <p>I'm <strong>Naveen</strong>, a passionate <strong>software developer</strong> and <strong>game developer</strong> on an exciting journey of growth. With each project and learning opportunity, I've embraced new technologies and challenges, continually <strong>expanding</strong> my skill set. I thrive on the thrill of learning, eagerly soaking up knowledge every day, no matter how small the detail.
                            <br />
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> Collaboration</strong> is key to my approach, having honed my teamwork skills through numerous projects during my academic journey. I hope this glimpse into my world gives you a better understanding of who I am and what drives me.</p>
                    </div>

                    <div className="image-container">
                        <img src={naveen} alt="Naveen N" />
                        <div className="image-cover">
                            <img src="https://avatars.githubusercontent.com/u/101534493?s=400&u=ffe43bcf0ad00518ba43d11b9023a371db2d86b2&v=4" alt="profile" />
                        </div>
                    </div>
                </section>
                <WhyMe />
                <Skills />
                <Learning />
            </div>
        </section>
    );
}

export default FullAboutMe;
